import { render } from "./CSearch.vue?vue&type=template&id=918fff38"
import script from "./CSearch.vue?vue&type=script&lang=js"
export * from "./CSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\igor.kondratiev\\Documents\\работа\\проекты\\faq\\faq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__